import { Box } from '@mui/material';
import CircularProgress, {
    CircularProgressProps,
} from '@mui/material/CircularProgress';

type Size = 'small' | 'medium' | 'large';
interface Props extends CircularProgressProps {
    size?: Size;
}

const SPINNER_SIZE_TO_PIXELS: { [Key in Size]: number } = {
    small: 25,
    medium: 60,
    large: 100,
};

export function Spinner(props: Props) {
    const { size = 'medium', ...rest } = props;

    const pixelSize = SPINNER_SIZE_TO_PIXELS[size];
    return (
        <Box display="flex" padding={`${pixelSize / 4}px`}>
            <CircularProgress color="primary" size={pixelSize} {...rest} />
        </Box>
    );
}
